import * as React from "react";
import { Box, Typography, useTheme, alpha } from "@mui/material";
import { Title } from "react-admin";
import CombinedInKindReport from "../../components/reports/thabat/CombinedInKindReport";

const Offers = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        background: `linear-gradient(135deg, ${alpha(
          theme.palette.background.default,
          0.9
        )} 0%, ${alpha(theme.palette.background.paper, 0.9)} 100%)`,
        p: 3,
        borderRadius: "16px",
      }}
    >
      <Title title="Offers Dashboard" />
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h4"
          fontWeight="800"
          sx={{
            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            display: "inline-block",
          }}
        >
          Offers (Donations)
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
          Manage all crop and service donations (type = donate)
        </Typography>
      </Box>
      <CombinedInKindReport itemType="donate" />
    </Box>
  );
};

export default Offers;